{
  "About Page": "About Page",
  "Add Element": "Add Element",
  "Add Image": "Add Image",
  "Add Link": "Add Link",
  "Add Logo": "Add Logo",
  "Add a branded footer.": "Add a branded footer.",
  "Add custom HTML and CSS.": "Add custom HTML and CSS.",
  "Add link to Calendar": "Add link to Calendar",
  "Address": "Address",
  "All Locations": "All Locations",
  "All locations must have a link for the campaign to be ready.": "All locations must have a link for the campaign to be ready.",
  "An unknown validation error occurred.": "An unknown validation error occurred.",
  "Automatically generate content for your email campaign.": "Automatically generate content for your email campaign.",
  "Back to Templates": "Back to Templates",
  "Beta": "Beta",
  "Blog": "Blog",
  "Bottom": "Bottom",
  "Broken Link": "Broken Link",
  "Business Links": "Business Links",
  "Button": "Button",
  "Button Color": "Button Color",
  "Button link is required.": "Button link is required.",
  "Button text is required.": "Button text is required.",
  "Cancel": "Cancel",
  "Change Your Link...": "Change Your Link...",
  "Click to Edit Button": "Click to Edit Button",
  "Color": "Color",
  "Confirmation": "Confirmation",
  "Confirmation Link": "Confirmation Link",
  "Contact Page": "Contact Page",
  "Corners": "Corners",
  "Custom": "Custom",
  "Custom Code": "Custom Code",
  "Custom Link": "Custom Link",
  "Custom Review": "Custom Review",
  "Custom Review Button": "Custom Review Button",
  "Design Your Landing Page Here": "Design Your Landing Page Here",
  "Done": "Done",
  "Email": "Email",
  "Enter Link Text": "Enter Link Text",
  "Enter Link URL": "Enter Link URL",
  "Enter a link...": "Enter a link...",
  "Enter text here...": "Enter text here...",
  "Error loading lading page data": "Error loading lading page data",
  "FAQ Page": "FAQ Page",
  "Facebook": "Facebook",
  "Facebook Review": "Facebook Review",
  "Facebook Review Button": "Facebook Review Button",
  "Footer": "Footer",
  "Form": "Form",
  "Frame": "Frame",
  "Google": "Google",
  "Google Review": "Google Review",
  "Google Review Button": "Google Review Button",
  "Height": "Height",
  "Help Center": "Help Center",
  "Image": "Image",
  "Image Spacing": "Image Spacing",
  "Insert a call to action button.": "Insert a call to action button.",
  "Insert an image.": "Insert an image.",
  "Insert header or body text.": "Insert header or body text.",
  "Layout": "Layout",
  "Left": "Left",
  "Link URL": "Link URL",
  "Link to Weave Private Review": "Link to Weave Private Review",
  "Link to a custom URL": "Link to a custom URL",
  "Link to a location's Facebook account": "Link to a location's Facebook account",
  "Link to a location's Google Reviews": "Link to a location's Google Reviews",
  "Logo": "Logo",
  "Map": "Map",
  "Missing Form": "Missing Form",
  "No Location Selected": "No Location Selected",
  "One or more locations do not have access to this form or packet. Inspect this element to resolve this issue.": "One or more locations do not have access to this form or packet. Inspect this element to resolve this issue.",
  "One or more locations have not connected to Facebook in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not connected to Facebook in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not connected to Google in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not connected to Google in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not defined a reply-to address. Inspect this element to resolve this issue.": "One or more locations have not defined a reply-to address. Inspect this element to resolve this issue.",
  "One or more locations have not properly configured their schedule yet.": "One or more locations have not properly configured their schedule yet.",
  "One or more locations have not selected a phone number in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not selected a phone number in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a custom reviews link in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a custom reviews link in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their FAQ page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their FAQ page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their about page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their about page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their blog in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their blog in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their contact page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their contact page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their custom other page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their custom other page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their help center in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their help center in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their map in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their map in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their promotional page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their promotional page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their referral page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their referral page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their shop in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their shop in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their web page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their web page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set an address in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set an address in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set this link": "One or more locations have not set this link",
  "Only one packet or form can be linked to this email at a time.": "Only one packet or form can be linked to this email at a time.",
  "Other": "Other",
  "Padding": "Padding",
  "Phone": "Phone",
  "Practice Address": "Practice Address",
  "Practice Email": "Practice Email",
  "Practice Phone": "Practice Phone",
  "Preference Center": "Preference Center",
  "Private Review Button": "Private Review Button",
  "Promotional Page": "Promotional Page",
  "Referral Page": "Referral Page",
  "Remove": "Remove",
  "Replace": "Replace",
  "Right": "Right",
  "Save": "Save",
  "Schedule": "Schedule",
  "Select": "Select",
  "Select Packet or Form": "Select Packet or Form",
  "Select or drag & drop options from the toolbar to build your landing page.": "Select or drag & drop options from the toolbar to build your landing page.",
  "Send Packet or Form": "Send Packet or Form",
  "Set Up Your Link...": "Set Up Your Link...",
  "Shop": "Shop",
  "Text": "Text",
  "Text Color": "Text Color",
  "This link has not been set yet": "This link has not been set yet",
  "Top": "Top",
  "Unable to save link updates. Please try again.": "Unable to save link updates. Please try again.",
  "Unsubscribe": "Unsubscribe",
  "Upload or Select Image": "Upload or Select Image",
  "Viewing:": "Viewing:",
  "Weave AI": "Weave AI",
  "Web Page": "Web Page",
  "With Link": "With Link",
  "Without Link": "Without Link",
  "Write a Facebook Review": "Write a Facebook Review",
  "Write a Google Review": "Write a Google Review",
  "Write a Private Review": "Write a Private Review",
  "Your Link": "Your Link",
  "Your Link: {{linkType}}": "Your Link: {{linkType}}",
  "Your Links": "Your Links",
  "Your Socials": "Your Socials",
  "{{count}} Locations_one": "{{count}} Location",
  "{{count}} Locations_other": "{{count}} Locations",
  "{{count}} location missing FAQ page link_one": "{{count}} location missing FAQ page link",
  "{{count}} location missing FAQ page link_other": "{{count}} locations missing FAQ page link",
  "{{count}} location missing Facebook connection_one": "{{count}} location missing Facebook connection",
  "{{count}} location missing Facebook connection_other": "{{count}} locations missing Facebook connection",
  "{{count}} location missing Google connection_one": "{{count}} location missing Google connection",
  "{{count}} location missing Google connection_other": "{{count}} locations missing Google connection",
  "{{count}} location missing a phone number_one": "{{count}} location missing a phone number",
  "{{count}} location missing a phone number_other": "{{count}} locations missing a phone number",
  "{{count}} location missing about page link_one": "{{count}} location missing about page link",
  "{{count}} location missing about page link_other": "{{count}} locations missing about page link",
  "{{count}} location missing blog link_one": "{{count}} location missing blog link",
  "{{count}} location missing blog link_other": "{{count}} locations missing blog link",
  "{{count}} location missing contact page link_one": "{{count}} location missing contact page link",
  "{{count}} location missing contact page link_other": "{{count}} locations missing contact page link",
  "{{count}} location missing custom review link_one": "{{count}} location missing custom review link",
  "{{count}} location missing custom review link_other": "{{count}} locations missing custom review link",
  "{{count}} location missing form or packet_one": "{{count}} location missing form or packet",
  "{{count}} location missing form or packet_other": "{{count}} locations missing form or packet",
  "{{count}} location missing help center link_one": "{{count}} location missing help center link",
  "{{count}} location missing help center link_other": "{{count}} locations missing help center link",
  "{{count}} location missing map link_one": "{{count}} location missing map link",
  "{{count}} location missing map link_other": "{{count}} locations missing map link",
  "{{count}} location missing other page link_one": "{{count}} location missing other page link",
  "{{count}} location missing other page link_other": "{{count}} locations missing other page link",
  "{{count}} location missing promotional page link_one": "{{count}} location missing promotional page link",
  "{{count}} location missing promotional page link_other": "{{count}} locations missing promotional page links",
  "{{count}} location missing referral page link_one": "{{count}} location missing referral page link",
  "{{count}} location missing referral page link_other": "{{count}} locations missing referral page link",
  "{{count}} location missing reply-to email address_one": "{{count}} location missing reply-to email address",
  "{{count}} location missing reply-to email address_other": "{{count}} locations missing reply-to email address",
  "{{count}} location missing shop link_one": "{{count}} location missing shop link",
  "{{count}} location missing shop link_other": "{{count}} locations missing shop link",
  "{{count}} location missing web page link_one": "{{count}} location missing web page link",
  "{{count}} location missing web page link_other": "{{count}} locations missing web page link",
  "{{count}} location need schedule configuration_one": "{{count}} location needs schedule configuration",
  "{{count}} location need schedule configuration_other": "{{count}} locations need schedule configuration",
  "{{count}} location without an address_one": "{{count}} location without an address",
  "{{count}} location without an address_other": "{{count}} locations without an address",
  "{{count}} missing button labels_one": "{{count}} missing button label",
  "{{count}} missing button labels_other": "{{count}} missing button labels",
  "{{count}} missing button links_one": "{{count}} missing button link",
  "{{count}} missing button links_other": "{{count}} missing button links",
  "{{count}} unknown validation errors_one": "{{count}} unknown validation error",
  "{{count}} unknown validation errors_other": "{{count}} unknown validation errors"
}
